import type { NodeViewRenderer } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CalloutView } from "./CalloutView";
import { DocLinkView } from "./DocLinkView";
import { blockView, codeBlockView, headingView } from "./dom-views";
import { GroupView } from "./GroupView";
import { ImageView } from "./ImageView";
import { KvPairView } from "./KvPairView";
import { PageBreakView } from "./PageBreakView";
import { PlaceholderView } from "./PlaceholderView";
import { tableView } from "./table-view";

/** Node views by C3 node name. Nodes not listed render through @klarity/schema's renderHTML. */
export const NODE_VIEWS: Record<string, NodeViewRenderer> = {
  heading: headingView,
  codeBlock: codeBlockView,
  klCodeLine: blockView("div", "kd-codeline"),
  klTable: tableView,
  klTableHeaderRow: blockView("tr", "kd-tr kd-tr--head"),
  klTableRow: blockView("tr", "kd-tr"),
  klTableCell: blockView("td", "kd-td"),
  klGroup: ReactNodeViewRenderer(GroupView),
  klKvPair: ReactNodeViewRenderer(KvPairView),
  klCallout: ReactNodeViewRenderer(CalloutView, { as: "div" }),
  klImage: ReactNodeViewRenderer(ImageView),
  pageBreak: ReactNodeViewRenderer(PageBreakView),
  docLink: ReactNodeViewRenderer(DocLinkView, { as: "span" }),
  placeholder: ReactNodeViewRenderer(PlaceholderView, { as: "span" }),
  klGroupList: blockView("div", "kd-groups"),
  klGroupItem: blockView("div", "kd-group__item"),
  klKeyValue: blockView("div", "kd-kv"),
};
